import { jsx as _jsx } from "react/jsx-runtime";
import s from './StatusDot.module.css';
export function StatusDot({ tone, size = 7 }) {
    return _jsx("span", { className: [s.dot, s[tone]].join(' '), style: { width: size, height: size } });
}
